module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/reports/reports.component.html
// module id = ./src/app/modules/reports/reports.component.html
// module chunks = main